import { createAsyncThunk } from '@reduxjs/toolkit'
import { paginationData } from '../Pagination/reducers'
import * as service from './MemberShipReminder.services'
import { toast } from 'react-toastify'
import _ from 'lodash'

export const MembershipRevenueBreakDown = createAsyncThunk(
    '@Membership/revenue-breakdown',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await service.MembershipRevenueBreakDownApi(data)

            if (Number(data?.params?._limit || 0) > 1) {
                // Pagination Section
                const limit = data?.params?._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data?.params?._page || 1,
                    totalPage: TotalPage || 1,
                    totalRecords: res?.totalRecords || 1
                }
                dispatch(paginationData(paginationObj))
            }

            return res
        } catch (err) {
            if (err?.message) {
                toast.error(err.message)
            }
            if (Number(data?.params?._limit || 0) > 1) {
                const paginationObj = {
                    page: 1,
                    totalPage: 1,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            if (!err.response) {
                throw err
            }
            if (err?.response?.data) {
                toast.error(err?.response?.data)
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const MemberListRevenueBreakDown = createAsyncThunk(
    '@Membership/revenue-breakdown-member-list',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.MemberListRevenueBreakDownApi(data)
            const finalResult = _.orderBy(
                _.map(res?.data, (o) => ({
                    ...o,
                    label: `${o.last_name} ${o.first_name}`,
                    value: o.user_id
                })),
                [(o) => _.lowerCase(o?.label)],
                ['asc']
            )

            return finalResult
        } catch (err) {
            if (!err.response) {
                throw err
            }
            if (err.response.data) {
                toast.error(err.response.data)
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const PlanListRevenueBreakDown = createAsyncThunk(
    '@Membership/revenue-breakdown-plan-list',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.PlanListRevenueBreakDownApi(data)
            const finalResult = _.orderBy(
                _.map(res?.data, (o) => ({
                    ...o,
                    label: o.plan_name,
                    value: o.club_membership_plans_id
                })),
                [(o) => _.lowerCase(o?.label)],
                ['asc']
            )

            return finalResult
        } catch (err) {
            if (!err.response) {
                throw err
            }
            if (err.response.data) {
                toast.error(err.response.data)
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const RevenueBreakDownGrandTotal = createAsyncThunk(
    '@Revenue-break-down/GrandTotal',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.RevenueBreakDownGrandTotalApi(data)
            const finalRes = {
                grand_total: _.sumBy(res?.data, (o) => Number(o.grand_total || 0.0)).toFixed(2),
                connected_accnt_amt: _.sumBy(res?.data, (o) =>
                    Number(o?.connected_accnt_amt || 0.0)
                ).toFixed(2),
                master_accnt_amt: _.sumBy(res?.data, (o) =>
                    Number(o?.master_accnt_amt || 0.0)
                ).toFixed(2)
            }
            return finalRes
        } catch (err) {
            if (err.message) {
                toast.error(err.message)
            } else if (!err.response) {
                throw err
            }
            if (err.response.data) {
                toast.error(err.response.data)
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const RevenueBreakDownExportToCsv = createAsyncThunk(
    '@Revenue-break-down/ExportToCsv',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.RevenueBreakDownExportToCsvApi(data)
            // console.log('Response:', res)

            // Create a blob URL for the CSV file with proper MIME type
            const blob = new Blob([res], { type: 'text/csv;charset=utf-8;' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'revenue_breakdown.csv')
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
            return { success: true }
        } catch (err) {
            if (err?.message) {
                toast.error(err.message)
            } else if (!err.response) {
                throw err
            }
            if (err?.response?.data) {
                const errorMsg = err?.response?.data?.message || err?.response?.data
                return rejectWithValue(errorMsg)
            }
            return rejectWithValue(err.response.data)
        }
    }
)